import { render, staticRenderFns } from "./VReports.vue?vue&type=template&id=af44b264&"
import script from "./VReports.vue?vue&type=script&lang=js&"
export * from "./VReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports